export default __webpack_public_path__ + "static/media/YAS0400.34I-27636_-17183_0.b58f3cd5.jpg";